<template>
  <v-card>
    <v-card-title>
      Adding a basic person entry 
      <span v-if="prettyName" class="pl-1">for {{prettyName}}</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row align="center">

          <v-form
            ref="form"
            v-model="valid"
          >
            <v-text-field
              v-model="firstName"
              :rules="nameRules"
              label="First name"
              required
            ></v-text-field>
            
            <v-text-field
              v-model="middleName"
              label="Middle name"
            ></v-text-field>

            <v-text-field
              v-model="lastName"
              :rules="nameRules"
              label="Last name"
              required
            ></v-text-field>


            <v-btn
              :disabled="!valid"
              color="success"
              class="mr-4"
              @click="save"
            >
              SAVE
            </v-btn>

            <v-btn
              class="mr-4"
              @click="cancel"
            >
              CANCEL
            </v-btn>

          </v-form>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  
  export default {
    props: {
      splitName: Object
    },
    data () {
      return {
        valid: true,
        firstName: this.splitName && this.splitName.first,
        lastName: this.splitName && this.splitName.last,
        middleName: this.splitName && this.splitName.middle,
        nameRules: [
          v => !!v || 'Name is required'
        ],
        email: '',
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ]
      }
    },
    computed: {
      prettyName () {
        return `${this.firstName} ${this.lastName}`
      }
    },
    methods: {
      save () {
        this.$emit('save', {
          firstName: this.firstName,
          lastName: this.lastName,
          middleName: this.middleName
        })
      },
      cancel () {
        this.$emit('cancel')
      }
    },
  }
</script>





  
